import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

import { hashMD5 } from '../../../../components/Auth/AuthUtils';

import { dataAtualFormatada, horaAtualFormatada } from '../../../../util/FuncoesComuns';

import IUnidadeUnitizadoresItensGeralAlerta from '../../interfaces/IUnidadeUnitizadoresItensGeralAlerta';
import { imageLogoEctSVG } from '../../../../util/SVGConstants';

const downloadAnaliticoPendentesPdf = (unitizadores: IUnidadeUnitizadoresItensGeralAlerta[],usuario:any, filtro:string) => {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

    const data =dataAtualFormatada('dia', '/');
    const hora = horaAtualFormatada();
    let dataFiltro = unitizadores[0].dataExpedicao.split(' ')[0];
    let fcom = filtro ? `&  (${filtro})` : '';
    dataFiltro = fcom ? `${dataFiltro} ${fcom}` : dataFiltro;
    let totais = {
        qtdLinhas: 0
    }

    const reportTitle:any = [
          [{
			margin: [25, 25, 25, 5],
            headerRows: 1,
			table: {
                widths: [130,235,160],
                body: [
                    [
                        {
                            svg: imageLogoEctSVG,
                            height: 13,
                            width: 95,
                            alignment: 'center',
                            fontSize: 10,
                        },
                        {
                            text: 'CONFERÊNCIA ELETRÔNICA',
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                            fontSize: 10,
                        },
                        {
                            text: `Data: ${data} Hora: ${hora}`,
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                            fontSize: 10,
                        }
                    ]
                ]
            }
          },
          {
			margin: [25, 3, 25, 5],
            headerRows: 1,
			table: {
                widths: [234,300],
                body: [[                    
                    {
                        text: `Unidade: ${usuario.unidadeSro.codigoSro} - ${usuario.unidadeSro.nome}/${usuario.unidadeSro.superintendencia.sigla}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: `Filtro: ${dataFiltro}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
          },
          {
			margin: [25, 3, 5, 3],
            headerRows: 1,
			table: {
                widths: [125,235,165],
                body: [[
                    {
                        text: 'Relatório: PENDENTES',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },                    
                    {
                        text: `Usuário: ${usuario.sub} - ${usuario.nome}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: 'Conferente:',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
          }
        ]     
    ];

    const dados = unitizadores.map((uni) => {

        totais.qtdLinhas++;


        return [
            {text: uni.seOrigem, fontSize: 7, margin: [0,0,0,0]},
            {text: `${uni.uniOrigem.length > 37 ? uni.uniOrigem.substring(0,37) : uni.uniOrigem}`, fontSize: 7, margin: [0,0,0,0]},
            {text: uni.dataExpedicao, fontSize: 7, margin: [0,0,0,0]},
            {text: uni.dataRecebido, fontSize: 7, margin: [0,0,0,0]},
            {text: uni.numUnitizador, fontSize: 7, margin: [0,0,0,0]},
            {text: uni.objeto || ' ', fontSize: 7, alignment:'left', margin: [0,0,0,0]},
            {text: uni.carga || ' ', fontSize: 7, alignment:'center', margin: [0,0,0,0]}
        ] 
    });


    let qtdListas = totais.qtdLinhas <= 1 ? `${totais.qtdLinhas} Objeto.` : `${totais.qtdLinhas} Objetos.`
    const detailsTotais:any = [                           
                        {colSpan:7,text: qtdListas, fontSize: 9, margin: [0,0,0,0],alignment: 'center',bold: true,border: [true,true,true,true]}                   
    ];

    dados.push(detailsTotais);

    const details:any = [
        {
            table:{
                headerRows: 1,
                widths: [14, 178, 66,66,48,55, 25],
                body: [
                    [
                        {text: 'SE', style: 'tableHeader', fontSize: 9},
                        {text: 'Origem', style: 'tableHeader', fontSize: 9},
                        {text: 'Enviado', style: 'tableHeader', fontSize: 9},
                        {text: 'Recebido', style: 'tableHeader', fontSize: 9},
                        {text: 'Englobador', style: 'tableHeader', fontSize: 9},
                        {text: 'Objeto', style: 'tableHeader', fontSize: 9},
                        {text: 'Carga', style: 'tableHeader', fontSize: 9},
                    ],
                    ...dados
                ]
            },
            margin: [13, 5, 25, 5],
            layout: 'lightHorizontalLines' // headerLineOnly
        }
    ];

    function Rodape(currentPage: Number, pageCount: Number){

        let hash=hashMD5(`${usuario.unidadeSro.codigoSro}${usuario.sub}${data} ${hora}${totais.qtdLinhas}`).toString();

        return [
            {
            widths: [768],
            margin: [25, 5, 25, 5],
            headerRows: 1,
            columns:[{
              text: `Identificador documento: ${hash.toUpperCase()}`,
              alignment: 'left',
              fontSize: 9,
            },
            {
                text: `Página ${currentPage} de ${pageCount}`,
                alignment: 'right',
                fontSize: 9,
            }]}
        ]
    }

    const docDefinitios: any = {
        pageSize: 'A4',
        pageMargins: [15, 105, 15, 30],
        header: [reportTitle],
        content: [details],
        footer: Rodape
    }

    pdfMake.createPdf(docDefinitios).download(`AnaliticoPendentesGerado_${data.replaceAll('/','')}.pdf`);
}

export default downloadAnaliticoPendentesPdf;